module.exports = __webpack_public_path__ + "static/img/loading.7aba39f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/loading.gif
// module id = 3+W1
// module chunks = 0